class ErrorHandler {
  // TODO buscar por todo el codigo handleFailRequest hay que mejorarlo
  public static handleFailRequest(error: any): object {
    try {
      console.log('ERROR HANDLER ', error);
      const { response } = error;
      const { data, status } = response;
      // El cuerpo del error puede ser un string plano (el "SERVICE UNAVAILABLE"
      // del servidor local) o el JSON del gateway. Y success va SIEMPRE a false:
      // con undefined, getErrorMessage daba el fallo por respuesta valida y
      // registerSale seguia encadenando sobre una factura a medias.
      const body = typeof data === 'string' ? data : (data && (data.data || data.message));
      return {
        success: false,
        status: status,
        message: body || `Error HTTP ${status}`
      };
    } catch (error) {
      return {
        success: false,
        message: 'An error was courred while operating.'
      }
    }
  }

}

export default ErrorHandler;